import React, { memo, useEffect, useMemo, useState, useCallback} from 'react';
import moment from 'moment';
import { string } from 'prop-types';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import { twitterPageURL } from '../../util/urlHelpers';
import config from '../../config';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import {
  ExternalLink,
  IconSocialMediaFacebook,
  IconSocialMediaInstagram,
  Logo,
  NamedLink,
} from '../../components';
import { pushGTMBrowseEvent } from '../../util/gtm/gtmHelpers';
import {
  EVENT_BROWSE_ABOUTUS,
  EVENT_BROWSE_FLEXPLUS,
  EVENT_BROWSE_HOWITWORKS,
  EVENT_BROWSE_POLICIES,
  EVENT_BROWSE_RENTACAR,
  EVENT_BROWSE_SHAREACAR,
  EVENT_BROWSE_TRUSTANDSAFE,
} from '../../util/gtm/gtmConstants';
import LogoImage from '../../assets/logos/drive-mate-footer-logo.png';
import css from './Footer.css';
import { event_trigger_ids } from '../../util/analyticsConstants';
import { triggerAnalyticsEvent } from '../../util/amplitudeMapEvents';
import { useSelector } from 'react-redux';
import { getEventsByBucket } from '../../util/gtm/gtmCreateProperties';

const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
const DOMAIN_HELP_URL = process.env.REACT_APP_DOMAIN_HELP_URL;

const renderSocialMediaLinks = intl => {
  const { siteFacebookPage, siteInstagramPage, siteTwitterHandle } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const goToFb = intl.formatMessage({ id: 'Footer.goToFacebook' });
  const goToInsta = intl.formatMessage({ id: 'Footer.goToInstagram' });

  const fbLink = siteFacebookPage ? (
    <ExternalLink key="linkToFacebook" href={siteFacebookPage} className={css.icon} title={goToFb}>
      <IconSocialMediaFacebook />
    </ExternalLink>
  ) : null;

  const instragramLink = siteInstagramPage ? (
    <ExternalLink
      key="linkToInstagram"
      href={siteInstagramPage}
      className={css.icon}
      title={goToInsta}
    >
      <IconSocialMediaInstagram />
    </ExternalLink>
  ) : null;
  return [fbLink, instragramLink].filter(v => v != null);
};

// const handleLinkClick = (eventId, label) => {
//   console.log("Ahdnle first link clicked")
//   const { currentUser } = this.props;
//   const { eventData } = this.state;

//   triggerAnalyticsEvent({
//     event_id: eventId,
//     eventData,
//     props: {
//       ui: {
//         button: label,
//         page: 'ProfileScreen'
//       },
//     },
//     userId: currentUser && currentUser.id ? currentUser.id.uuid : null,
//     user: currentUser
//   });
// };

const Footer = memo(
  props => {
    const { rootClassName, className, intl, bookingPanelMobileHeight = 0 } = props;
    const socialMediaLinks = useMemo(() => renderSocialMediaLinks(intl), [intl]);
    const classes = classNames(rootClassName || css.root, className);
    const currentYear = moment(new Date()).format('YYYY');
    const [eventData, setEventData] = useState({});
    const currentUser = useSelector(state => state.user.currentUser);
    // const pushGTMBrowse = event => {
    //   pushGTMBrowseEvent({
    //     props,
    //     event,
    //   });
    // };
    const pushGTMBrowse = useCallback(event => {
      pushGTMBrowseEvent({
        props,
        event,
      });
    }, [props]);
    

    

    // useEffect(async()=>{
    //   try {
    //     const response = await getEventsByBucket('browsing');
    //     setEventData(response.data);
    //   } catch (error) {
    //     console.error('Error fetching event data:', error);
    //   }
    // },[]);

    useEffect(() => {
      const fetchEventData = async () => {
        try {
          const response = await getEventsByBucket('browsing');
          setEventData(response.data);
        } catch (error) {
          console.error('Error fetching event data:', error);
        }
      };
      fetchEventData();
    }, []);

    const handleLinkClick = (eventId, label) => {
      console.log("Footer first link clicked")

      triggerAnalyticsEvent({
        event_id: eventId,
        eventData,
        props: {
          ui: {
            button: label,
            page: 'ProfileScreen'
          },
        },
        userId: currentUser && currentUser.id ? currentUser.id.uuid : null,
        user: currentUser
      });
    };
    return (
      <div className={classes}>
        <div className={css.topBorderWrapper}>
          <div className={css.content}>
            
            <div className={css.links}>
              <div className={css.organization} id="organization">
                <NamedLink name="LandingPage" className={css.logoLink}>
                  <Logo format="desktop" className={css.logo} logoSrc={LogoImage} />
                </NamedLink>
                <div className={css.organizationInfo}>
                  <p className={css.organizationDescription}>
                    <FormattedMessage id="Footer.organizationDescription" />
                  </p>
                  <p className={css.FooterAddress}>
                    <FormattedMessage id="Footer.Address" />
                  </p>
                  <p className={css.FooterAddress}>
                  <a href="tel:+61341602205" className={css.FooterAddress}>Call us: <span style={{textDecoration: "underline"}}>+61341602205</span></a>
                  </p>
                  <p className={css.organizationCopyright}>
                    <NamedLink name="LandingPage" className={css.copyrightLink}>
                      <FormattedMessage id="Footer.copyright" values={{ currentYear }} />
                    </NamedLink>
                  </p>
                </div>
              </div>
              {/* <div className={css.searches}>
                <ul className={css.list}>
                  <li className={css.listItem}></li>
                </ul>
              </div> */}
              <div className={css.infoLinks}>
                <ul className={css.list}>
                  <li className={css.listItem}>
                    <NamedLink
                      name="BecomeAGuestPage"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_RENTACAR)}
                    >
                      <FormattedMessage id="Footer.rentACar" />
                    </NamedLink>
                  </li>
                  <li className={css.listItem}>
                    <NamedLink
                      name="BecomeAHostPage"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_SHAREACAR)}
                    >
                      <FormattedMessage id="Footer.shareYourCar" />
                    </NamedLink>
                  </li>
                  <li className={css.listItem}>
                    <NamedLink
                      name="HowItWorkPage"
                      className={css.link}
                      onClick={() => handleLinkClick(event_trigger_ids.BROWSE_CLICK_HOW_IT_WORKS, "How it works")}
                    >
                      <FormattedMessage id="Footer.howItWork" />
                    </NamedLink>
                  </li>
                  <li className={css.listItem}>
                    <NamedLink
                      name="LandingPageFlex"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_FLEXPLUS)}
                    >
                      <FormattedMessage id="Footer.Flex+" />
                    </NamedLink>
                  </li>
                  <li className={css.listItem}>
                    <NamedLink
                      name="TrustAndSafetyPage"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_TRUSTANDSAFE)}
                    >
                      <FormattedMessage id="Footer.trustAndSafety" />
                    </NamedLink>
                  </li>
                  <li className={css.listItem}>
                    <NamedLink
                      name="LandingPageFlex"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_FLEXPLUS)}
                    >
                      <FormattedMessage id="Footer.Flex+" />
                    </NamedLink>
                  </li>
                  {/* <li className={css.listItem}>
                    <NamedLink
                      name="HowItWorkPage"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_HOWITWORKS)}
                    >
                      <FormattedMessage id="Footer.howItWork" />
                    </NamedLink>
                  </li> */}
                  {/* <li className={css.listItem}>
                    <NamedLink
                      name="LandingPageGo"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_TRUSTANDSAFE)}
                    >
                      Drive mate Go™
                    </NamedLink>
                  </li> */}
                </ul>
              </div>
              <div className={css.someLiksMobile}>{socialMediaLinks}</div>
              <div className={css.searchesExtra}>
                <ul className={css.list}>
                  {/* <li className={css.listItem}>
                    <NamedLink
                      name="AboutPage"
                      className={css.link}
                      onClick={() => pushGTMBrowse(EVENT_BROWSE_ABOUTUS)}
                    >
                    <FormattedMessage id="Footer.aboutUs" />
                    </NamedLink>
                  </li> */}
                  <li className={css.listItem}>
                    <ExternalLink className={css.link} href={`https://help.${DOMAIN_HELP_URL}/kb/en`}>
                      <FormattedMessage id="Footer.toFAQPage" />
                    </ExternalLink>
                  </li>
                  <li className={css.listItem}>
                    <ExternalLink href={`https://help.${DOMAIN_HELP_URL}/`} className={css.link}>
                      <FormattedMessage id="Footer.help" />
                    </ExternalLink>
                  </li>
                  {/* <li className={css.listItem} onClick={() => pushGTMBrowse(EVENT_BROWSE_POLICIES)}>
                    <ExternalLink
                      href={`https://help.${DOMAIN_HELP_URL}/kb/en`}
                      className={css.link}
                    >
                      <FormattedMessage id="Footer.policies" />
                    </ExternalLink>
                  </li> */}
                  <li className={css.listItem}>
                    <ExternalLink href={`https://drivemate.au/blog`} className={css.link}>
                      <FormattedMessage id="Footer.blog" />
                    </ExternalLink>
                  </li>
                  <li className={css.listItem}>
                    <NamedLink name="ContactUsPage" className={css.link}>
                      <FormattedMessage id="Footer.contactUs" />
                    </NamedLink>
                  </li>
  
                </ul>
              </div>
              {/* <div className={css.searchesExtra}>
                <ul className={css.list}>
                  <li className={css.listItem}>
                    <div className={css.ourPartners}>Our partners</div>
                    
                  </li>
                  <li className={css.listItem}>
                    <ExternalLink href={'https://www.allianz.com/en.html'} className={css.link}>
                      Allianz
                    </ExternalLink>
                  </li>
                  <li className={css.listItem}>
                    <ExternalLink href={'https://www.gtins.com.au/'} className={css.link}>
                      GT Insurance
                    </ExternalLink>
                  </li>
                </ul>
              </div> */}
             
              <div className={css.extraLinks}>
                <div className={css.someLinks}>{socialMediaLinks}</div>
                <div className={css.legalMatters}>
                  <ul className={css.tosAndPrivacy}>
                    <li>
                      <NamedLink name="TermsOfServicePage" className={css.legalLink}>
                        <FormattedMessage id="Footer.termsOfUse" />
                      </NamedLink>
                    </li>
                    <li>
                      <NamedLink name="RentalAgreementPage" className={css.legalLink}>
                        <FormattedMessage id="Footer.rentalAgreement" />
                      </NamedLink>
                    </li>
                    <li>
                      <NamedLink name="PrivacyPolicyPage" className={css.legalLink}  onClick={() =>
                    handleLinkClick(event_trigger_ids.BROWSE_VIEW_PRIVACY_POLICY, 'Privacy policy')
                  }>
                        <FormattedMessage id="Footer.privacyPolicy" />
                      </NamedLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div
  className={css.copyrightAndTermsMobile}
  style={
    bookingPanelMobileHeight
      ? { marginBottom: (bookingPanelMobileHeight * 40) / 100 }
      : {}
  }
>
  <div className={css.footerCopy}>
    <NamedLink name="LandingPage" className={css.organizationCopyrightMobile}>
      <FormattedMessage id="Footer.copyright" values={{ currentYear }} />
    </NamedLink>
  </div>
  <div className={css.callUsMobile}>
    <a style={{ color: "#b2b2b2" }} href="tel:+61341602205" className={css.FooterAddress}>
      Call us: <span style={{ textDecoration: "underline" }}>+61341602205</span>
    </a>
  </div>
   <div >
  <div className={css.tosAndPrivacyMobile}>
    <NamedLink name="TermsOfServicePage" className={css.terms}>
      <FormattedMessage id="Footer.terms" />
    </NamedLink>
    <NamedLink name="RentalAgreementPage" className={css.rental}>
      <FormattedMessage id="Footer.rentalAgreement" />
    </NamedLink>
    <NamedLink name="PrivacyPolicyPage" className={css.privacy}>
      <FormattedMessage id="Footer.privacyPolicy" />
    </NamedLink>
  </div>
</div>
           
              {/* <p className={css.FooterAddressMobile} >
                <FormattedMessage id="Footer.Address" />
              </p> */}
              {/* <p className={css.FooterAddressMobile}>
                  <a style={{color: "#b2b2b2"}} href="tel:+61341602205" className={css.FooterAddress}>Call us: <span style={{textDecoration: "underline"}}>+61341602205</span></a>
                  </p> */}
            </div>
          </div>
        </div>
      </div>
    );
  },
  (prev, next) => isEqual(prev.bookingPanelMobileHeight, next.bookingPanelMobileHeight)
);

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);